import authToken from 'src/utils/auth';

export const requestFullHeaders = () => {
  const token = authToken();

  return (
    (token && {
      'JWT-ACCESS-TOKEN': token.accessToken,
      'JWT-REFRESH-TOKEN': token.refreshToken,
    }) ||
    {}
  );
};

export default () => {
  const token = authToken();

  return (
    (token && {
      'JWT-ACCESS-TOKEN': token.accessToken,
    }) ||
    {}
  );
};
